export default __webpack_public_path__ + "d095db2a74c6b9363e08d9951826b57321b59941/88bf19232e48cd6fe29f018005128e1e.png";